































































import {
  Component, Mixins, Watch,
} from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import AuthModule from '@/store/modules/Auth';
import Pagination from '@/components/Pagination.vue';
import PointModule from '@/store/modules/Point';
import Table from '@/components/Table/Index.vue';
import LottoBody from '@/components/Table/LottoBody.vue';
import ToolMixin from '@/mixins/Tool.vue';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import PaginationMixin from '@/mixins/Pagination.vue';
import DateRangeLogBody from '@/components/Table/DateRangeLog.vue';
import LottoData from '@/data/LottoData';

@Component({
  components: {
    Table,
    Pagination,
    LottoBody,
    DateRangeLogBody,
  },
})
export default class Lotto extends Mixins(
  ToolMixin, ErrorHandleMixin, PaginationMixin,
) {
  AuthInstance = getModule(AuthModule, this.$store);

  PointInstance = getModule(PointModule, this.$store);

  resultData: object = {};

  dataList: any = [];

  roundId = '';

  TableHead = [...LottoData.TableHead];

  startDate = '';

  endDate = '';

  footSummery: object = {};

  isSearch = false;

  PaginationDetail = {
    current: 1,
    amount: 0,
    limit: 100,
  }

  sumFooter = {}

  currentDuration = 'Today'

  Criteria = {
    ...this.Period,
    isSearch: false,
    roundId: '',
    limit: 100,
    current: 1,
  };

  momentFormat = {
    stringify: (date) => this.$moment(date).format('DD-MM-YYYY'),
    parse: (value) => this.$moment(value).format('DD-MM-YYYY'),
  }

  @Watch('Period.start.date', { immediate: true, deep: true })
  watchPeriodStartDate() {
    const dateStart = this.$moment(this.Period.start.date).format('L');
    this.startDate = this.$moment(dateStart).format('DD-MM-YYYY');
  }

  @Watch('Period.end.date', { immediate: true, deep: true })
  watchPeriodEndDate() {
    const dateEnd = this.$moment(this.Period.end.date).format('L');
    this.endDate = this.$moment(dateEnd).format('DD-MM-YYYY');
  }

  handleSearch() {
    this.isSearch = true;
    this.Criteria.roundId = this.roundId.trim();
    this.currentTool = 'Today';
  }

  created() {
    this.fetchLotto();
  }

  initial() {
    this.roundId = '';
    this.Criteria = {
      ...this.Period,
      isSearch: false,
      limit: 100,
      current: 1,
      roundId: '',
    };
  }

  async fetchLotto() {
    this.GeneralInstance.toggleLoading(true);
    const criteria: any = {
      ...this.Criteria,
      ...this.Period,
    };
    const res = await this.PointInstance.FetchLotto(criteria);
    if (res) {
      this.dataList = res.result;
      this.PaginationDetail.amount = res.pagination.pageAmount;
      this.sumFooter = res.footer;
    }
    this.GeneralInstance.toggleLoading(false);
    this.isSearch = false;
    this.initial();
  }

  onSubmit() {
    this.fetchLotto();
  }

  changePage(i) {
    this.PaginationDetail.current = i;
    this.fetchLotto();
  }
}
